import { tns } from "tiny-slider";

export const customerLogosSlider = () => {
    const customerLogosSliderContainer = document.getElementById('customer-logos-slider');
    if (customerLogosSliderContainer) {
        tns({
            responsive: {
                0: {
                    items: 1,
                    fixedWidth: 0
                },
                639: {
                    fixedWidth: 150
                },
            },
            container: customerLogosSliderContainer,
            startIndex: 0,
            autoplay: false,
            loop: true,
            fixedWidth: 150,
            controlsContainer: customerLogosSliderContainer.parentElement.nextElementSibling,
            swipeAngle: false,
            nav: false,

        })
    }
}
